import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useThemeMode } from '../../design-system/theme';
import { EducationDesignPreview } from '../education/EducationDesignExperiment';
import NextChallengePage from './NextChallengePage';
import './ChallengePageClarityHome.css';

/** Current public run, resolved in place. Review only; no experiment enrollment. */
export default function ChallengeClarityHomeReview(): React.ReactElement {
  const [theme] = useThemeMode();
  return (
    <div
      className="challenge-home-review"
      data-testid="challenge-home-review"
      data-bs-theme={theme}
      data-experiment-active="false"
    >
      <Helmet>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <EducationDesignPreview variant="control">
        <NextChallengePage presentation="clarity-home" />
      </EducationDesignPreview>
    </div>
  );
}
